"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiProvider = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _swrConfig = require("../constants/swrConfig");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve */

const ApiProvider = ({
  children
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    token
  } = (0, _auth.useToken)();
  const {
    staticApiUrl,
    globalApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi', 'globalApi']);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_fetching.SWRConfig, {
    value: _swrConfig.swrConfig,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
      baseUrl: globalApiUrl,
      tenant: tenant,
      language: language,
      token: token,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_staticApiClientReact.ApiClientProvider, {
        baseUrl: staticApiUrl,
        language: language,
        tenant: tenant,
        children: children
      })
    })
  });
};
exports.ApiProvider = ApiProvider;
